<template>
  <div class="col-form-label">
    <v-label :text="item" class="badge-label">
      <template v-if="isRequired">
        <v-chip label variant="outlined" density="compact" class="badge-require"
          >必須</v-chip
        >
      </template>
      <template v-if="isInfo">
        <v-tooltip
          :location="placement"
          :max-width="maxWidth"
          content-class="rounded badge-popover"
        >
          <template v-slot:activator="{ props }">
            <v-icon
              v-bind="props"
              icon="$mdiInformationOutline"
              size="small"
              class="badge-info"
            ></v-icon>
          </template>
          <div>
            <span class="msg-pre-line">{{ msg }}</span>
          </div>
        </v-tooltip>
      </template>
    </v-label>
    <slot name="others"></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";

/**
 * formのlabel要素コンポーネント
 * props
 *  item:項目名
 *  isRequired(必須マーク):true(表示-default),false(非表示)
 *  isInfo(infoマーク):true(表示-default),false(非表示)
 *  placement(infoの表示位置):top(default),bottom,start,end
 *  msg:infoに表示するメッセージ
 *
 * content slot-othersはinfo-必須以外が必要な場合に利用してください。
 */
export default defineComponent({
  name: "AppBadge",
  props: {
    // 項目名
    item: {
      type: String as PropType<string>,
      required: true,
    },
    // 必須マーク
    // true:必要
    // false:不要
    isRequired: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: true,
    },
    // infoマーク
    // true:必要
    // false:不要
    isInfo: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: true,
    },
    // infoの表示位置
    // https://vuetifyjs.com/en/components/tooltips/#location
    placement: {
      type: String as PropType<"top" | "bottom" | "start" | "end">,
      required: false,
      default: "top",
    },
    // infoに表示する文言
    msg: {
      type: String as PropType<string>,
      required: false,
      default: "",
    },
    // infoアリアの最大幅
    // https://vuetifyjs.com/en/components/tooltips/#props-max-width
    maxWidth: {
      type: String as PropType<string>,
      required: false,
      default: "300px",
    },
  },
});
</script>

<style lang="scss" scoped>
.msg-pre-line {
  white-space: pre-line;
}

.v-chip.v-chip--size-default {
  padding: 5px;
  margin-left: 10px;
  color: black;
  font-size: 75%;
  font-weight: 700;
}

.v-chip.v-chip--density-compact {
  height: calc(var(--v-chip-height) - 12px);
}

.v-icon {
  margin-left: 10px;
}
</style>
